export enum VersionType {
  /** WCH沁恒芯片固件 */
  USB = 'USB',
  /** Nordic主控固件 */
  MasterControl = 'MasterControl',
  /** 射频模组固件 */
  RF = 'RF',
  /** 通用固件 */
  Firmware = 'Firmware',
  /** 屏幕固件 */
  Screen = 'Screen',
}

export enum DeviceType {
  /** 鼠标设备本体 */
  Mouse = 'Mouse',
  /** 接收器 */
  Receiver = 'Receiver',
  /** 底座 */
  Base = 'Base',
  /** 键盘设备本体 */
  Keyboard = 'Keyboard',
}

/**
 * 固件版本是否具备执行升级的资格。
 * `any-version` 只放宽版本高低判断，不绕过协议和硬件安全门。
 */
export type FirmwareVersionPolicy = 'newer-only' | 'any-version'

/** SDK 独立使用时默认保持正式环境的严格升级策略。 */
export const DEFAULT_FIRMWARE_VERSION_POLICY: FirmwareVersionPolicy = 'newer-only'

export interface VersionInfo {
  /** 设备当前固件版本号 */
  version: string
  /** checkFirmwareUpdate 查询到的对应芯片线上版本；缺失时展示层回退 version。 */
  onlineVersion?: string
  /** 版本类型（USB/MasterControl/RF/Firmware/Screen） */
  versionType: VersionType
  /** 设备类型（Mouse/Receiver/Base/Keyboard） */
  deviceType: DeviceType
  /** 是否有可用更新 */
  canUpdate?: boolean
  /** 其他字段，理论仅供当前型号sdk内部使用 */
  [key: string]: string | boolean | number | undefined
}

/** 远程设备版本信息（单个设备） */
export interface RemoteDeviceVersion {
  /** 固件版本 */
  FirmwareVersion?: string
  /** 硬件版本 */
  HardwareVersion?: string
  /** 透传版本 */
  TransparentVersion?: string
  /** 屏幕版本 */
  ScreenVersion?: string
  /** 固件下载地址 */
  FirmwareURL?: string
  /** 透传下载地址 */
  TransparentURL?: string
  /** 屏幕下载地址 */
  ScreenURL?: string
  /** 16K回报率升级驱动下载地址 */
  ReportRate16KURL?: string
  /** 其他未知字段 */
  [key: string]: string | undefined
}
